/* eslint formatjs/no-literal-string-in-jsx: "error" */
import { PageHeader } from "../views/molecules/Molecules"
import React from "react"
import { useIntl } from "react-intl"

const TalkToCarrotChatHeader = () => {
  const intl = useIntl()
  const pageHeaderTitle = intl.formatMessage({
    defaultMessage: "Talk to Carrot"
  })

  return <PageHeader icon="icn-talk-to-carrot" title={pageHeaderTitle} />
}

export { TalkToCarrotChatHeader }
